var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-36",
    "data-name": "50_Kids_Icons-36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#ffc34a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4728",
    "data-name": "Group 4728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4684",
    "data-name": "Group 4684",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M142.9,217.31c1.125,2.664.512,5.254-1.368,5.784s-4.317-1.2-5.442-3.864-.512-5.254,1.368-5.784S141.777,214.646,142.9,217.31Z",
    transform: "translate(-114.352 -180.015)",
    fill: "#bd6442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M326.238,217.31c-1.125,2.664-.512,5.254,1.368,5.784s4.317-1.2,5.441-3.864.513-5.254-1.368-5.784S327.363,214.646,326.238,217.31Z",
    transform: "translate(-274.788 -180.014)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4685",
    "data-name": "Group 4685",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M115.961,399.234l-.009-.144c0-8.781-3.287-17.288-7.3-18.908L91.559,373.3a22.645,22.645,0,0,0-14.6-.019L59.62,380.2c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144h63.654Z",
    transform: "translate(-44.134 -313.94)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4686",
    "data-name": "Group 4686",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M224.15,250.8a6.825,6.825,0,0,1-6.825,6.825H216.5a6.825,6.825,0,0,1-6.825-6.825V233.22A6.825,6.825,0,0,1,216.5,226.4h.828a6.825,6.825,0,0,1,6.825,6.825Z",
    transform: "translate(-176.912 -191.021)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4688",
    "data-name": "Group 4688",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4687",
    "data-name": "Group 4687",
    transform: "translate(25.312 11.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M191.374,100.877a14.688,14.688,0,0,1-14.688,14.688h0A14.688,14.688,0,0,1,162,100.877V88.66a14.688,14.688,0,0,1,14.688-14.688h0A14.688,14.688,0,0,1,191.374,88.66v12.217Z",
    transform: "translate(-161.998 -73.972)",
    fill: "#d67f5e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4689",
    "data-name": "Group 4689",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(32.67 35.598)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(43.933 35.598)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4690",
    "data-name": "Group 4690",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M162.891,69.792c-9.523,0-17.242,8.367-17.242,18.689a19.809,19.809,0,0,0,2.338,9.4l.565-4.794A11.025,11.025,0,0,1,159.5,83.353h6.778a11.025,11.025,0,0,1,10.95,9.732l.567,4.8a19.812,19.812,0,0,0,2.338-9.4C180.134,78.159,172.414,69.792,162.891,69.792Z",
    transform: "translate(-122.891 -58.887)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4691",
    "data-name": "Group 4691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M243.3,253.581a2.616,2.616,0,0,1-5.106.591,2.768,2.768,0,0,0-.125.78,2.8,2.8,0,1,0,5.6,0A2.765,2.765,0,0,0,243.3,253.581Z",
    transform: "translate(-200.873 -213.959)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4692",
    "data-name": "Group 4692",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M115.952,413.291c0-8.781-3.287-17.288-7.3-18.908l-13.591-5.475a12,12,0,0,1-21.828.058L59.62,394.4c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144h63.654Z",
    transform: "translate(-44.134 -328.141)",
    fill: "#d12c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4693",
    "data-name": "Group 4693",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 3.43,
    cy: 2.572,
    rx: 3.43,
    ry: 2.572,
    transform: "translate(46.002 38.995)",
    fill: "#bd6442"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 3.43,
    cy: 2.572,
    rx: 3.43,
    ry: 2.572,
    transform: "translate(27.139 38.995)",
    fill: "#bd6442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4694",
    "data-name": "Group 4694",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M226.93,287.411a5.359,5.359,0,0,1-7.119,0c-1.351-1.272-3.392.761-2.037,2.037a8.3,8.3,0,0,0,11.193,0c1.355-1.276-.686-3.309-2.037-2.037Z",
    transform: "translate(-183.371 -242.163)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4709",
    "data-name": "Group 4709",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4701",
    "data-name": "Group 4701",
    transform: "translate(24.202 9.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4695",
    "data-name": "Group 4695"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 2.96,
    cy: 3.453,
    rx: 2.96,
    ry: 3.453,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 7.789)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 2.96,
    cy: 3.453,
    rx: 2.96,
    ry: 3.453,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.739, 5.408)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4696",
    "data-name": "Group 4696",
    transform: "translate(1.469 4.692)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 2.855,
    cy: 3.331,
    rx: 2.855,
    ry: 3.331,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 7.512)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 2.855,
    cy: 3.331,
    rx: 2.855,
    ry: 3.331,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.642, 5.216)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4697",
    "data-name": "Group 4697",
    transform: "translate(4.842 8.635)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 2.75,
    cy: 3.208,
    rx: 2.75,
    ry: 3.208,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 7.236)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 2.75,
    cy: 3.208,
    rx: 2.75,
    ry: 3.208,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.545, 5.025)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4698",
    "data-name": "Group 4698",
    transform: "translate(9.524 11.623)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 2.645,
    cy: 3.086,
    rx: 2.645,
    ry: 3.086,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.96)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 2.645,
    cy: 3.086,
    rx: 2.645,
    ry: 3.086,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.448, 4.833)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4699",
    "data-name": "Group 4699",
    transform: "translate(14.919 13.451)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 2.54,
    cy: 2.963,
    rx: 2.54,
    ry: 2.963,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.684)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 2.54,
    cy: 2.963,
    rx: 2.54,
    ry: 2.963,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.351, 4.641)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4700",
    "data-name": "Group 4700",
    transform: "translate(20.433 13.912)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 2.435,
    cy: 2.841,
    rx: 2.435,
    ry: 2.841,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.408)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 2.435,
    cy: 2.841,
    rx: 2.435,
    ry: 2.841,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.254, 4.45)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4708",
    "data-name": "Group 4708",
    transform: "translate(25.938 9.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4702",
    "data-name": "Group 4702",
    transform: "translate(18.403)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 3.453,
    cy: 2.96,
    rx: 3.453,
    ry: 2.96,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.739, 5.189)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 3.453,
    cy: 2.96,
    rx: 3.453,
    ry: 2.96,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.808)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4703",
    "data-name": "Group 4703",
    transform: "translate(17.34 4.692)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    cx: 3.331,
    cy: 2.855,
    rx: 3.331,
    ry: 2.855,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.642, 5.005)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 3.331,
    cy: 2.855,
    rx: 3.331,
    ry: 2.855,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.709)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4704",
    "data-name": "Group 4704",
    transform: "translate(14.373 8.635)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 3.208,
    cy: 2.75,
    rx: 3.208,
    ry: 2.75,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.545, 4.821)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_221",
    "data-name": "Ellipse 221",
    cx: 3.208,
    cy: 2.75,
    rx: 3.208,
    ry: 2.75,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.609)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4705",
    "data-name": "Group 4705",
    transform: "translate(10.098 11.623)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_222",
    "data-name": "Ellipse 222",
    cx: 3.086,
    cy: 2.645,
    rx: 3.086,
    ry: 2.645,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.448, 4.637)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 3.086,
    cy: 2.645,
    rx: 3.086,
    ry: 2.645,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.509)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4706",
    "data-name": "Group 4706",
    transform: "translate(5.108 13.451)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 2.963,
    cy: 2.54,
    rx: 2.963,
    ry: 2.54,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.351, 4.453)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 2.963,
    cy: 2.54,
    rx: 2.963,
    ry: 2.54,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.41)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4707",
    "data-name": "Group 4707",
    transform: "translate(0 13.911)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_226",
    "data-name": "Ellipse 226",
    cx: 2.841,
    cy: 2.435,
    rx: 2.841,
    ry: 2.435,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 2.254, 4.269)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_227",
    "data-name": "Ellipse 227",
    cx: 2.841,
    cy: 2.435,
    rx: 2.841,
    ry: 2.435,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 2.31)",
    fill: "#3d2a3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4724",
    "data-name": "Group 4724",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4716",
    "data-name": "Group 4716",
    transform: "translate(30.392 7.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4710",
    "data-name": "Group 4710",
    transform: "translate(21.091 7.246)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(1.871 5.753) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_229",
    "data-name": "Ellipse 229",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(0 8.772) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4711",
    "data-name": "Group 4711",
    transform: "translate(18.766 3.572)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "translate(1.804 5.549) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 2.794,
    cy: 3.26,
    rx: 2.794,
    ry: 3.26,
    transform: "translate(0 8.461) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4712",
    "data-name": "Group 4712",
    transform: "translate(14.879 1.15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "translate(1.738 5.345) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 2.691,
    cy: 3.14,
    rx: 2.691,
    ry: 3.14,
    transform: "translate(0 8.15) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4713",
    "data-name": "Group 4713",
    transform: "translate(10.045)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "translate(1.672 5.141) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 2.589,
    cy: 3.02,
    rx: 2.589,
    ry: 3.02,
    transform: "translate(0 7.84) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4714",
    "data-name": "Group 4714",
    transform: "translate(4.88 0.142)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "translate(1.605 4.937) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 2.486,
    cy: 2.9,
    rx: 2.486,
    ry: 2.9,
    transform: "translate(0 7.529) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4715",
    "data-name": "Group 4715",
    transform: "translate(0 1.596)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "translate(1.539 4.734) rotate(-83.24)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 2.383,
    cy: 2.781,
    rx: 2.383,
    ry: 2.781,
    transform: "translate(0 7.218) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_240",
    "data-name": "Ellipse 240",
    cx: 2.897,
    cy: 3.38,
    rx: 2.897,
    ry: 3.38,
    transform: "translate(24.41 15.71) rotate(-83.24)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4723",
    "data-name": "Group 4723",
    transform: "translate(17.8 7.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4717",
    "data-name": "Group 4717",
    transform: "translate(1.448 7.245)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(0 0.796) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(1.87 3.815) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4718",
    "data-name": "Group 4718",
    transform: "translate(4.101 3.571)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "translate(0 0.767) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 3.26,
    cy: 2.794,
    rx: 3.26,
    ry: 2.794,
    transform: "translate(1.804 3.68) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4719",
    "data-name": "Group 4719",
    transform: "translate(8.317 1.15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "translate(0 0.739) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 3.14,
    cy: 2.691,
    rx: 3.14,
    ry: 2.691,
    transform: "translate(1.738 3.544) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4720",
    "data-name": "Group 4720",
    transform: "translate(13.48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "translate(0 0.711) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    cx: 3.02,
    cy: 2.589,
    rx: 3.02,
    ry: 2.589,
    transform: "translate(1.672 3.409) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4721",
    "data-name": "Group 4721",
    transform: "translate(18.973 0.142)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "translate(0 0.683) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_250",
    "data-name": "Ellipse 250",
    cx: 2.9,
    cy: 2.486,
    rx: 2.9,
    ry: 2.486,
    transform: "translate(1.605 3.274) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4722",
    "data-name": "Group 4722",
    transform: "translate(24.181 1.597)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "translate(0 0.655) rotate(-6.76)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_252",
    "data-name": "Ellipse 252",
    cx: 2.781,
    cy: 2.383,
    rx: 2.781,
    ry: 2.383,
    transform: "translate(1.539 3.139) rotate(-6.76)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    cx: 3.38,
    cy: 2.897,
    rx: 3.38,
    ry: 2.897,
    transform: "translate(0 10.751) rotate(-6.76)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4727",
    "data-name": "Group 4727",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4725",
    "data-name": "Group 4725",
    transform: "translate(30.512 32.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M196.873,209.837a9.168,9.168,0,0,1,4.327-.877,1.053,1.053,0,0,0,0-2.105,11.422,11.422,0,0,0-5.39,1.165c-1.215.607-.148,2.423,1.063,1.818Z",
    transform: "translate(-195.274 -206.851)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4726",
    "data-name": "Group 4726",
    transform: "translate(43.012 32.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M280.619,209.837a9.168,9.168,0,0,0-4.327-.877,1.053,1.053,0,0,1,0-2.105,11.423,11.423,0,0,1,5.39,1.165c1.215.607.148,2.423-1.062,1.818Z",
    transform: "translate(-275.274 -206.851)",
    fill: "#3d2a3d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar19);
export default __webpack_public_path__ + "static/media/avatar19.4c1a537da963af12f27774239fa29718.svg";
export { ForwardRef as ReactComponent };